<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="contenedorprincipal">
    <div class="d-flex justify-content-between flex-wrap">
        <div class="p-1">
            <div class="tarjetaafiliaciones d-flex flex-row">
                <div class="iconafiliados"><img src="../../../assets/img/totalafiliados.png" alt=""></div>
                <div class="contenedortitulos">
                    <p class="titulolinea1">Afiliados en</p>
                    <p class="titulolinea2">Riesgo</p>
                    <p [class]="this.ClaseValorPorcentaje(this.porcentajeTotalMesAnterior)">{{this.porcentajeTotalMesAnterior}} %</p>
                </div>
                <div class="contenedortitulos">
                    <div class="d-flex flex-wrap">
                        <p class="titulovalor">{{this.descripcionTotalMesAnterior}}</p>
                        <div [class]="this.IconoValorPorcentaje(this.porcentajeTotalMesAnterior)"><mat-icon>{{this.TipoIconoValorPorcentaje(this.porcentajeTotalMesAnterior)}}</mat-icon></div>
                    </div>
                    <p class="titulodescripcionvalor">frente periodo anterior</p>
                </div>
            </div>
        </div>
        <div class="p-1">
            <div class="tarjetaafiliaciones d-flex flex-row">
                <div class="iconafiliados"><img src="../../../assets/img/nuevosafiliados.png" alt=""></div>
                <div class="contenedortitulos">
                    <p class="titulolinea1">Expedientes</p>
                    <p class="titulolinea2">Nuevos</p>
                    <p [class]="this.ClaseValorPorcentaje(this.porcentajeExpedientesNuevosMesAnterior)">{{this.porcentajeExpedientesNuevosMesAnterior}} %</p>
                </div>
                <div class="contenedortitulos">
                    <div class="d-flex flex-wrap">
                        <p class="titulovalor">{{this.descripcionExpedientesNuevosMesAnterior}}</p>
                        <div [class]="this.IconoValorPorcentaje(this.porcentajeExpedientesNuevosMesAnterior)"><mat-icon>{{this.TipoIconoValorPorcentaje(this.porcentajeExpedientesNuevosMesAnterior)}}</mat-icon></div>
                    </div>
                    <p class="titulodescripcionvalor">periodo actual</p>
                </div>
            </div>
        </div>
        <div class="p-1">
            <div class="tarjetaafiliaciones d-flex flex-row">
                <div class="iconafiliados"><img src="../../../assets/img/totalafiliados.png" alt=""></div>
                <div class="contenedortitulos">
                    <p class="titulolinea1">Expedientes</p>
                    <p class="titulolinea2">Concluidos</p>
                    <p [class]="this.ClaseValorPorcentaje(this.porcentajeExpedientesConcluidosMesAnterior)">{{this.porcentajeExpedientesConcluidosMesAnterior}} %</p>
                </div>
                <div class="contenedortitulos">
                    <div class="d-flex flex-wrap">
                        <p class="titulovalor">{{this.descripcionExpedientesConcluidosMesAnterior}}</p>
                        <div [class]="this.IconoValorPorcentaje(this.porcentajeExpedientesConcluidosMesAnterior)"><mat-icon>{{this.TipoIconoValorPorcentaje(this.porcentajeExpedientesConcluidosMesAnterior)}}</mat-icon></div>
                    </div>
                    <p class="titulodescripcionvalor">periodo actual</p>
                </div>
            </div>
        </div>
        <div class="p-1">
            <div class="tarjetaafiliaciones d-flex flex-row">
                <div class="iconafiliados"><img src="../../../assets/img/inactivoafiliados.png" alt=""></div>
                <div class="contenedortitulos">
                    <p class="titulolinea1">Expedientes</p>
                    <p class="titulolinea2">Asignados</p>
                    <p [class]="this.ClaseValorPorcentaje(this.porcentajeExpedientesAsignadosMesAnterior)">{{this.porcentajeExpedientesAsignadosMesAnterior}} %</p>
                </div>
                <div class="contenedortitulos">
                    <div class="d-flex flex-wrap">
                        <p class="titulovalor">{{this.descripcionExpedientesAsignadosMesAnterior}}</p>
                        <div [class]="this.IconoValorPorcentaje(this.porcentajeExpedientesAsignadosMesAnterior)"><mat-icon>{{this.TipoIconoValorPorcentaje(this.porcentajeExpedientesAsignadosMesAnterior)}}</mat-icon></div>
                    </div>
                    <p class="titulodescripcionvalor">periodo actual</p>
                </div>
            </div>
        </div>
        <div class="p-1">
            <div class="tarjetaafiliaciones d-flex flex-row">
                <div class="iconafiliados"><img src="../../../assets/img/inactivoafiliados.png" alt=""></div>
                <div class="contenedortitulos">
                    <p class="titulolinea1">Afiliados</p>
                    <p class="titulolinea2">Inactivos</p>
                    <p [class]="this.ClaseValorPorcentaje(this.porcentajeInactivosMesAnterior)">{{this.porcentajeInactivosMesAnterior}} %</p>
                </div>
                <div class="contenedortitulos">
                    <div class="d-flex flex-wrap">
                        <p class="titulovalor">{{this.descripcionInactivosMesAnterior}}</p>
                        <div [class]="this.IconoValorPorcentaje(this.porcentajeInactivosMesAnterior)"><mat-icon>{{this.TipoIconoValorPorcentaje(this.porcentajeInactivosMesAnterior)}}</mat-icon></div>
                    </div>
                    <p class="titulodescripcionvalor">frente periodo anterior</p>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-between flex-wrap mt-4">
        <div>
            <h2 class="tituloprincipal">
                <a type="button" (click)="CancelarRegistro()" *ngIf="this.mostrarBotonRegresar">
                    <mat-icon class="iconoregresar">chevron_left</mat-icon>
                </a>
                Dashboard de Gestión
            </h2>
        </div>
        <div class="contenedorbusqueda d-flex">
            <div class="flex-fill">
                <input class="textobusqueda w-100" placeholder="Identificación o expediente..." [(ngModel)]="this.textoBusqueda" (keyup.enter)="Consultar()">
            </div>
            <div class="flex-fill d-flex justify-content-end">
                <button (click)="Consultar()" mat-icon-button type="button">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="mt-3">
        <div class="contenedortituloexpedientes d-flex justify-content-between flex-wrap cursorpointer" (click)="CambiarExpanderNuevo()">
            <div class="d-flex flex-row">
                <div>
                    <mat-icon>
                        {{this.mostrarExpedientesNuevos ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
                <p class="tituloexpansionpanel">
                    Expedientes nuevos ({{this.CantidadExpedientesNuevos()}} Objetos)
                </p>
            </div>
            <div class="paginador" (click)="ClicPaginacion($event)">
                <mat-paginator #paginatorNuevos="matPaginator" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page of users"></mat-paginator>
            </div>
        </div>
        <div class="pl-0 pr-0 mat-elevation-z8" *ngIf="this.mostrarExpedientesNuevos">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceNuevos" matSort class="table table-striped table-hover">
    
                    <!-- expediente Column -->
                    <ng-container matColumnDef="expediente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Expediente </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" class="columnaexpediente">
                                {{row.codigoExpediente}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- subservicio Column -->
                    <ng-container matColumnDef="subservicio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Subservicio </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" [title]="row.subServicio" class="columnasubservicio">
                                {{(row.subServicio.length > 33) ? ((row.subServicio).slice(0, 33) + '...') : row.subServicio}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- estado Column -->
                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                        <td mat-cell *matCellDef="let row"> 
                            <div class="txtEstadoNuevo">
                                <a type="button" (click)="AbrirDetalle(row)">
                                    {{row.estado}}
                                </a>
                            </div>
                        </td>
                    </ng-container>
                    <!-- afiliado Column -->
                    <ng-container matColumnDef="afiliado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Afiliado </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.afiliado}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- propietario Column -->
                    <ng-container matColumnDef="propietario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Propietario </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.propietario}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- responsable Column -->
                    <ng-container matColumnDef="responsable">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsable </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.responsable}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- fecha Column -->
                    <ng-container matColumnDef="fecha">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de creación </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.fecha | fechapipe:true}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- cola Column -->
                    <ng-container matColumnDef="cola">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cola </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.cola}} 
                            </a>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>
    
                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="contenedortituloexpedientes d-flex justify-content-between flex-wrap cursorpointer mt-3" (click)="CambiarExpanderProceso()">
            <div class="d-flex flex-row">
                <div>
                    <mat-icon>
                        {{this.mostrarExpedientesProceso ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
                <p class="tituloexpansionpanel">
                    Expedientes en proceso ({{this.CantidadExpedientesProceso()}} Objetos)
                </p>
            </div>
            <div class="paginador" (click)="ClicPaginacion($event)">
                <mat-paginator #paginatorProceso="matPaginator" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page of users"></mat-paginator>
            </div>
        </div>
        <div class="pl-0 pr-0 mat-elevation-z8" *ngIf="this.mostrarExpedientesProceso">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceProceso" matSort class="table table-striped table-hover">

                    <!-- expediente Column -->
                    <ng-container matColumnDef="expediente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Expediente </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" class="columnaexpediente">
                                {{row.codigoExpediente}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- subservicio Column -->
                    <ng-container matColumnDef="subservicio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Subservicio </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" [title]="row.subServicio" class="columnasubservicio">
                                {{(row.subServicio.length > 33) ? ((row.subServicio).slice(0, 33) + '...') : row.subServicio}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- estado Column -->
                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                        <td mat-cell *matCellDef="let row"> 
                            <div class="txtEstadoProceso">
                                <a type="button" (click)="AbrirDetalle(row)">
                                    {{row.estado}}
                                </a>
                            </div>
                        </td>
                    </ng-container>
                    <!-- afiliado Column -->
                    <ng-container matColumnDef="afiliado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Afiliado </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.afiliado}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- propietario Column -->
                    <ng-container matColumnDef="propietario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Propietario </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.propietario}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- responsable Column -->
                    <ng-container matColumnDef="responsable">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsable </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.responsable}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- fecha Column -->
                    <ng-container matColumnDef="fecha">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de creación </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.fecha | fechapipe:true}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- cola Column -->
                    <ng-container matColumnDef="cola">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cola </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.cola}} 
                            </a>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>
    
                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="contenedortituloexpedientes d-flex justify-content-between flex-wrap cursorpointer mt-3" (click)="CambiarExpanderSeguimiento()">
            <div class="d-flex flex-row">
                <div>
                    <mat-icon>
                        {{this.mostrarExpedientesSeguimiento ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
                <p class="tituloexpansionpanel">
                    Expedientes en seguimiento ({{this.CantidadExpedientesSeguimiento()}} Objetos)
                </p>
            </div>
            <div class="paginador" (click)="ClicPaginacion($event)">
                <mat-paginator #paginatorSeguimiento="matPaginator" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page of users"></mat-paginator>
            </div>
        </div>
        <div class="pl-0 pr-0 mat-elevation-z8" *ngIf="this.mostrarExpedientesSeguimiento">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceSeguimiento" matSort class="table table-striped table-hover">

                    <!-- expediente Column -->
                    <ng-container matColumnDef="expediente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                            Expediente 
                        </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" class="columnaexpediente">
                                {{row.codigoExpediente}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- subservicio Column -->
                    <ng-container matColumnDef="subservicio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Subservicio </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" [title]="row.subServicio" class="columnasubservicio">
                                {{(row.subServicio.length > 33) ? ((row.subServicio).slice(0, 33) + '...') : row.subServicio}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- estado Column -->
                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                            Estado
                        </th>
                        <td mat-cell *matCellDef="let row"> 
                            <div class="txtEstadoSeguimiento">
                                <a type="button" (click)="AbrirDetalle(row)">
                                    {{row.estado}}
                                </a>
                            </div>
                        </td>
                    </ng-container>
                    <!-- afiliado Column -->
                    <ng-container matColumnDef="afiliado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Afiliado </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.afiliado}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- propietario Column -->
                    <ng-container matColumnDef="propietario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Propietario </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.propietario}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- responsable Column -->
                    <ng-container matColumnDef="responsable">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsable </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.responsable}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- fecha Column -->
                    <ng-container matColumnDef="fecha">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de creación </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.fecha | fechapipe:true}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- cola Column -->
                    <ng-container matColumnDef="cola">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cola </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.cola}} 
                            </a>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>
    
                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="contenedortituloexpedientes d-flex justify-content-between flex-wrap cursorpointer mt-3" (click)="CambiarExpanderTerminado()">
            <div class="d-flex flex-row">
                <div>
                    <mat-icon>
                        {{this.mostrarExpedientesTerminado ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} 
                    </mat-icon>
                </div>
                <p class="tituloexpansionpanel">
                    Expedientes en termino ({{this.CantidadExpedientesTerminado()}} Objetos)
                </p>
            </div>
            <div class="paginador" (click)="ClicPaginacion($event)">
                <mat-paginator #paginatorTerminado="matPaginator" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page of users"></mat-paginator>
            </div>
        </div>
        <div class="pl-0 pr-0 mat-elevation-z8" *ngIf="this.mostrarExpedientesTerminado">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSourceTerminado" matSort class="table table-striped table-hover">
    
                    <!-- expediente Column -->
                    <ng-container matColumnDef="expediente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                            Expediente
                        </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" class="columnaexpediente">
                                {{row.codigoExpediente}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- subservicio Column -->
                    <ng-container matColumnDef="subservicio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Subservicio 
                        </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)" [title]="row.subServicio" class="columnasubservicio">
                                {{(row.subServicio.length > 33) ? ((row.subServicio).slice(0, 33) + '...') : row.subServicio}}
                            </a>
                        </td>
                    </ng-container>
                    <!-- estado Column -->
                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                            Estado
                        </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                <div class="txtEstadoTerminado">
                                    {{row.estado}}
                                </div>
                            </a>
                        </td>
                    </ng-container>
                    <!-- afiliado Column -->
                    <ng-container matColumnDef="afiliado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Afiliado </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.afiliado}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- propietario Column -->
                    <ng-container matColumnDef="propietario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Propietario </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.propietario}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- responsable Column -->
                    <ng-container matColumnDef="responsable">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsable </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.responsable}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- fecha Column -->
                    <ng-container matColumnDef="fecha">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de creación </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.fecha | fechapipe:true}} 
                            </a>
                        </td>
                    </ng-container>
                    <!-- cola Column -->
                    <ng-container matColumnDef="cola">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cola </th>
                        <td mat-cell *matCellDef="let row"> 
                            <a type="button" (click)="AbrirDetalle(row)">
                                {{row.cola}} 
                            </a>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>
    
                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>